
import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { LeadDetailView } from '../../../lead-detail-view/lead-detail-view';
import { PopupModal } from '../../../../shared/popup-modal/popup-modal';
import { MafInsurerTile } from '../../../../shared/maf/maf-insurer-tile/maf-insurer-tile';
import { AppReviewApiService } from '../../services/app-review-api.service';
import { AppTooltipComponent } from '../../../../shared/app-tooltip/app-tooltip.component';

export interface LeadInfoData {
  clientName: string;
  clientInitials: string;
  leadId: string;
  lastActivityText: string;
  lastActivityTime: string;
  quoteReference: string;
  quoteVersion: string;
  insurer: string;
  planName: string;
  network: string;
  leadCreatedOn: string;
  noOfApplicants: number;
  assignedAgent: string;
  assignedReviewer: string;
}

export interface LeadInfoDialogData {
  data: Record<string, unknown>;
  leadSourceDD?: Array<{ value: string | number; label: string }>;
  initialTab?: 'profile' | 'activities' | 'documents';
  activityMode?: 'email' | 'note';
}

@Component({
  selector: 'app-lead-info',
  imports: [CommonModule, MatIconModule, PopupModal, MafInsurerTile, AppTooltipComponent],
  templateUrl: './lead-info.html',
  styleUrl: './lead-info.scss',
})
export class LeadInfo {
  private readonly dialog = inject(MatDialog);
  private readonly appReviewApiService = inject(AppReviewApiService);

  @Input() leadInfo: LeadInfoData = {
    clientName: '',
    clientInitials: '',
    leadId: '',
    lastActivityText: '',
    lastActivityTime: '',
    quoteReference: '',
    quoteVersion: '',
    insurer: '',
    planName: '',
    network: '',
    leadCreatedOn: '',
    noOfApplicants: 0,
    assignedAgent: '',
    assignedReviewer: '',
  };

  @Input() selectedLead: any = null;
  @Input() productId: string = '';
  @Input() leadInfoId: string = '';

  isCollapsed = false;

  get isUnassignedReviewer(): boolean {
    return this.leadInfo.assignedReviewer === 'Unassigned';
  }

  isTextOverflowing(element: HTMLElement | null): boolean {
    return !!element && (element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  openLeadDetails(): void {
    if (!this.selectedLead) {
      return;
    }

    const leadInfoId = String(this.selectedLead.leadInfoId ?? this.leadInfoId ?? '').trim();
    if (!leadInfoId) return;

    this.appReviewApiService.getLeadWithBasicInfo(leadInfoId).subscribe((response: any) => {
      this.dialog.open(LeadDetailView, {
        data: {
          viewOnly: true,
          data: {
            id: leadInfoId,
            lead_Id: this.selectedLead.lead_Id,
            lead_Status: this.selectedLead.leadStatus,
            lead_Stage_Name: this.selectedLead.leadStage,
            clientName: this.selectedLead.contactName,
            lastActivityText: this.selectedLead.lastActivity,
            lastActivityOn: this.selectedLead.lastActivityDate,
            created_On: this.selectedLead.dateCreated,
            sourceName: this.selectedLead.leadSource,
            source_Of_Lead_Id: this.selectedLead.leadSource_Id,
            insuranceCategoryName: this.selectedLead.categoryName,
            ownerAgentName: this.selectedLead.assignedAgent,
            priority: this.selectedLead.priorityName,
            ...(response?.body?.leadInfo ?? {}),
          },
          leadSourceDD: [],
          initialTab: 'profile',
        },
      });
    });
  }

  showQuoteModal = false;

  onQuoteReferenceClick(): void {
    this.showQuoteModal = true;
  }

  closeQuoteModal(): void {
    this.showQuoteModal = false;
  }
}
